import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CardActivityHome = () => {
  const settings = {
    centerMode: true, // Kích hoạt center mode
    centerPadding: "60px", // Khoảng cách xung quanh slide trung tâm
    slidesToShow: 3, // Số slide hiển thị cùng lúc
    infinite: true, // Vòng lặp
    focusOnSelect: true, // Cho phép click để chọn slide
    autoplay: true, // Tự động chạy
    autoplaySpeed: 2000, // Tốc độ chuyển đổi (ms)
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1, // Hiển thị 1 slide trên thiết bị nhỏ
          centerPadding: "30px",
        },
      },
    ],
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-center text-2xl font-bold mb-6">Center Mode Zoom</h2>
      <Slider {...settings}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index}>
            <div className="p-6 bg-gray-200 text-center rounded-lg transform transition-transform duration-500 hover:scale-110">
              <h3>Slide {index + 1}</h3>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CardActivityHome;
